export default "https://kr-a.kakaopagecdn.com/web/qa/5.3.1/static/icon-splash-bottom-text-76fc9afd3af7444e9d209b7298695476.svg";